import{jsx as o}from"react/jsx-runtime";import{FontIcon as e}from"@fluentui/react";const m=({onClick:m,className:r})=>o(e,{className:r,iconName:"ChromeClose",onClick:m});export{m as RemoveButton};
//# sourceMappingURL=RemoveButton.js.map
